import { GoogleAnalyticsService } from './analytics/google-analytics.service';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalService } from './core/services/local.service';
import { Toast } from 'primeng/toast';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { ConfirmDialog } from 'primeng/confirmdialog';
// import { ConfirmPopup } from 'primeng/confirmpopup';


@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    TranslateModule,
    Toast,
    ConfirmDialog,
    // ConfirmPopup,
  ],
  providers: [
    MessageService,
    ConfirmationService,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {

  constructor(
    private ga: GoogleAnalyticsService,
    private translateService: TranslateService,
    private localService: LocalService,
  ) {
    this.ga.start();
    Chart.register(ChartDataLabels);

    this.translateService.addLangs(['id', 'en']);
    this.translateService.setDefaultLang('en');

    this.localService.initEnvironment();

  }

  ngOnInit() {
    const savedLang = this.localService.getData('lang');
    this.translateService.use(savedLang || 'en');
  }
}
